// src/app/shared/services/config.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { shareReplay } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ConfigService {
  /** Ajuste o caminho se você colocar o JSON em outro lugar */
  private readonly cfg$: Observable<any> = this.http
    .get('/assets/data/config.json')
    .pipe(shareReplay(1));        // cacheia a resposta

  constructor(private http: HttpClient) {}

  /** Retorna o Observable com a configuração */
  getConfig() {
    return this.cfg$;
  }
}
